import { lazy } from 'react';

const Support = lazy(() => import('./SupportPage'));

const MerchantSupportConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'merchant/support',
      element: <Support />,
    },
  ],
};

export default MerchantSupportConfig;
